export default __webpack_public_path__ + "img/508445db0d91c7b41e1b004b5ed066fe.png";